import React from "react"

import { Grid, Divider } from '@material-ui/core'
import { EmojiFoodBeverageSharp } from "@material-ui/icons"

import { Link, graphql, useStaticQuery } from "gatsby"
import Img from 'gatsby-image'

import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"

import SEO from '../components/SEO'
import MainNav from '../components/nav'
import PreFooter from '../components/preFooter'
import Footer from '../components/footer'

import Styles from "./blog.module.scss"

const Blog = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlogPost(sort: { fields: publishedDate, order: DESC }) {
        edges {
          node {
            order
            type
            id
            title
            slug
            summary {
              summary
            }
            hero {
              fluid (maxWidth: 450, maxHeight: 300) {
                ...GatsbyContentfulFluid_tracedSVG
              }
              title
            }
            publishedDate(formatString: "MMMM Do, YYYY")
          }
        }
      }
    }
  `)

  return (
    <>
      <MainNav />

      <SEO title="Blog | Remodelmate" />

      <div className={Styles.headerContainer}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
            <div className={Styles.headerH1Container}>
              <h1 className={Styles.headerH1}>
                Blog
              </h1>
            </div>
            <div className={Styles.headerH1DividerMobile}>
              <Divider />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
            <div>
              <h2 className={Styles.headerH2}>
                <span style={{ fontFamily: 'HattonMedium', color: "#1B2230" }}>The Blueprint.</span> Your home renovation questions, answered.
              </h2>
            </div>
          </Grid>
        </Grid>
        <div className={Styles.headerH2Divider}>
              <Divider
                style={{ background: "#e2e2e2" }}
              />
            </div>
      </div>

      <Container className={Styles.postContainer}>
        <ol className={Styles.postOL}>
          <Row>
            {
              data.allContentfulBlogPost.edges.map((edge, i) => {
                if (i === 0) {
                  return (
                    <div className={Styles.postHeroContainer}>
                      <Grid container justify="center" alignItems="center">
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <div className={Styles.postImgHeroContainer}>
                            <Link
                              className={Styles.postLink}
                              to={`/blog/${edge.node.slug}`}
                            >
                              <Img className={Styles.postImgHero} fluid={edge.node.hero.fluid} alt={edge.node.hero.title} />
                            </Link>
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          <div className={Styles.postContentHeroContainer}>
                            <Link
                              style={{ textDecoration: "none" }}
                              to={`/blog/${edge.node.slug}`}
                            >
                              <p className={Styles.postDateHero}>{edge.node.publishedDate}</p>
                              <h2 className={Styles.postH2Hero}>{edge.node.title}</h2>
                              <p className={Styles.postSummaryHero}>{edge.node.summary.summary}</p>
                            </Link>
                            <Link
                              className={Styles.postReadMoreHero}
                              to={`/blog/${edge.node.slug}`}
                            >
                              <p>
                                Read more →
                              </p>
                            </Link>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  )
                }
                else {
                  return (
                    <Col className={Styles.postCol} sm={12} md={6} lg={4} key={edge.node.id}>
                      <li className={Styles.post}>
                        <Link
                          className={Styles.postLink}
                          to={`/blog/${edge.node.slug}`}
                        >
                        <Img className={Styles.postImg} fluid={edge.node.hero.fluid} alt={edge.node.hero.title} />
                        <p className={Styles.postDate}>{edge.node.publishedDate}</p>
                        <h2 className={Styles.postH2}>{edge.node.title}</h2>
                        <p className={Styles.postSummary}>{edge.node.summary.summary}</p>
                        </Link>
                      </li>
                    </Col>
                  )
                }      
              })
            }
          </Row>
        </ol>
      </Container>

      <PreFooter />

      <Footer />
    </>
  )
}

export default Blog